var _circle, _circle2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAnimateCircle = function SvgAnimateCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 100 100"
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 47,
    fill: "none",
    stroke: "#fff",
    strokeDasharray: "14.2472,14.2472",
    strokeMiterlimit: 15,
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    dur: "5s",
    from: "0 50 50",
    repeatCount: "indefinite",
    to: "360 50 50",
    type: "rotate"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 39,
    fill: "none",
    stroke: "#fff",
    strokeDasharray: "10,10",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    dur: "5s",
    from: "0 50 50",
    repeatCount: "indefinite",
    to: "-360 50 50",
    type: "rotate"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 35h5v30h-5z"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    begin: 0.1,
    dur: "1s",
    repeatCount: "indefinite",
    type: "translate",
    values: "0 5 ; 0 -5; 0 5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M40 35h5v30h-5z"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    begin: 0.2,
    dur: "1s",
    repeatCount: "indefinite",
    type: "translate",
    values: "0 5 ; 0 -5; 0 5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M50 35h5v30h-5z"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    begin: 0.3,
    dur: "1s",
    repeatCount: "indefinite",
    type: "translate",
    values: "0 5 ; 0 -5; 0 5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60 35h5v30h-5z"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    begin: 0.4,
    dur: "1s",
    repeatCount: "indefinite",
    type: "translate",
    values: "0 5 ; 0 -5; 0 5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M70 35h5v30h-5z"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    begin: 0.5,
    dur: "1s",
    repeatCount: "indefinite",
    type: "translate",
    values: "0 5 ; 0 -5; 0 5"
  })))));
};
export default SvgAnimateCircle;